/**
 * The Firebase web SDK does not expose the app instance ID, so web holds no value and the
 * appInstanceId event property / header are simply omitted.
 */
export const fetchAndCacheAppInstanceId = async (): Promise<void> => {};

export const getCachedAppInstanceId = (): string | undefined => undefined;
